import { render, staticRenderFns } from "./OficialDocumentTable.vue?vue&type=template&id=fa2a4304&"
import script from "./OficialDocumentTable.vue?vue&type=script&lang=js&"
export * from "./OficialDocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./OficialDocumentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports